import React from 'react';
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { SingleAttachmentInputFormField } from '../../../../components/SingleAttachmentInputFormField';

interface PropTypes {
  formRegister: UseFormRegister<CandidateDto>;
  getValues: UseFormGetValues<CandidateDto>;
  setValue: UseFormSetValue<CandidateDto>;
  captionText?: string;
}

export function CandidateCoverLetterInput(props: PropTypes) {
  return (
    <Row>
      <Col xs={6}>
        <SingleAttachmentInputFormField<CandidateDto>
          getValues={props.getValues}
          setValue={props.setValue}
          formRegister={props.formRegister}
          headerClassNames='fw-semibold'
          controllerContentName='coverLetter.content'
          controllerFileName='coverLetter.filename'
          controllerIdName='coverLetter.id'
          fieldName={'Cover Letter'}
          allowedFormats={['.pdf', '.doc', '.docx']}
          maxFileSizeMb={10}
          isRequired={false}
          disabled={false}
        />
        {props.captionText && (
          <small className='text-muted'>{props.captionText}</small>
        )}
      </Col>
    </Row>
  );
}
